import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const ProductiveReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/productive/hoursSold`);
    }
  }, [match]);

  return null;
};

export default ProductiveReportsPage;
